module.exports = __webpack_public_path__ + "static/media/Frame.18de362c.png";